const SN = {
  ibanLength: 28,
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.idNumber",
      required: true,
    },
    IBAN: {
      visible: true,
      required: true,
      label: "bankDetails.IBAN",
    },
    accountNumber: {
      visible: false,
      required: false,
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
    },
    bankName: {
      visible: false,
      required: false,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { SN };
